<div class="mass-os-ticket-expand">
  <div *ngIf="loading" class="mass-os-ticket-expand__loading">
    <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
    <span>Cargando tickets…</span>
  </div>

  <table
    *ngIf="!loading"
    mat-table
    [dataSource]="tickets"
    class="mass-os-tickets-table"
  >
    <ng-container matColumnDef="Check">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--select"></th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--select">
        <mat-checkbox
          *ngIf="!hasOrder(ticket)"
          [checked]="isTicketChecked(ticket.id)"
          [disabled]="!canSelectTicket(ticket)"
          [matTooltip]="canSelectTicket(ticket) ? '' : getTicketDisableReason(ticket)"
          [matTooltipDisabled]="canSelectTicket(ticket)"
          matTooltipPosition="above"
          (change)="onTicketToggle(ticket, $event.checked)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--fecha">Fecha de Creación</th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--fecha">
        <div class="mass-os-tickets-table__cell-row">
          <span>{{ ticket.createdAt | date: 'dd MMM yyyy' }}</span>
          <span
            *ngIf="ticket.estadoTicket === 'CREADO'"
            class="mass-os-tickets-table__tag-nuevo"
          >Nuevo</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="ticketTipos">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--tipo">Tipo de Ticket</th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--tipo">
        <div class="mass-os-tickets-table__cell-row">
          <div class="mass-os-tickets-table__tipo-col">
            <ng-container *ngIf="ticket.ticketTipos?.length; else sinTipos">
              <div *ngFor="let item of ticket.ticketTipos" class="mass-os-tickets-table__tipo-line">
                {{ item.cantidad }} - {{ item.tipo }}
              </div>
            </ng-container>
            <ng-template #sinTipos>-</ng-template>
          </div>
          <button
            *ngIf="!hasOrder(ticket)"
            mat-icon-button
            type="button"
            class="mass-os-tickets-table__action-inline"
            [disabled]="!canEditNumberTickets(ticket)"
            (click)="editTicketNumber(ticket); $event.stopPropagation()"
          >
            <i-tabler
              name="pencil"
              [ngClass]="canEditNumberTickets(ticket) ? 'mass-os-tickets-table__icon--active' : 'mass-os-tickets-table__icon--blocked'"
            ></i-tabler>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="monto">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--monto">Monto</th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--monto">
        <div class="mass-os-tickets-table__cell-row">
          <span>{{ ticket.total != null ? ticket.moneda : '' }} {{ ticket.total != null ? (ticket.total | formatNumber) : '-' }}</span>
          <button
            *ngIf="!hasOrder(ticket)"
            mat-icon-button
            type="button"
            class="mass-os-tickets-table__action-inline"
            [disabled]="!canEditAmount(ticket)"
            (click)="editTicketAmount(ticket); $event.stopPropagation()"
          >
            <i-tabler
              name="pencil"
              [ngClass]="canEditAmount(ticket) ? 'mass-os-tickets-table__icon--active' : 'mass-os-tickets-table__icon--blocked'"
            ></i-tabler>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="estadoTicket">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--estado">Estado de Ticket</th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--estado">
        <ng-container [ngSwitch]="ticket?.estadoTicket">
          <span *ngSwitchCase="'RESERVADO'" class="mass-os-tickets-table__tag-estado mass-os-tickets-table__tag-estado--reservado">Reservado</span>
          <span *ngSwitchCase="'CREADO'" class="mass-os-tickets-table__tag-estado mass-os-tickets-table__tag-estado--creado">Creado</span>
          <span *ngSwitchCase="'EN_PROCESO'" class="mass-os-tickets-table__tag-estado mass-os-tickets-table__tag-estado--proceso">En Proceso</span>
          <span *ngSwitchCase="'CONFIRMADO'" class="mass-os-tickets-table__tag-estado mass-os-tickets-table__tag-estado--confirmado">Confirmado</span>
          <span *ngSwitchDefault>{{ ticket?.estadoTicket || '-' }}</span>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="estadoOS">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--estado">Estado de OS</th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--estado">
        <span
          *ngIf="ticket?.order?.orderStatus; else noTicketOrderStatus"
          class="os-status"
          [attr.data-os-status]="ticket.order.orderStatus.toUpperCase()"
        >
          {{ ticket.order.orderStatus }}
        </span>
        <ng-template #noTicketOrderStatus>-</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="numeroOS">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--numero">Nro. de OS</th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--numero">
        {{ ticket.order?.displayCode || ticket.order?.orderNumber || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="fechaOS">
      <th mat-header-cell *matHeaderCellDef class="mass-os-tickets-table__col--fecha-os">Fecha de OS Generada</th>
      <td mat-cell *matCellDef="let ticket" class="mass-os-tickets-table__col--fecha-os">
        {{ ticket.order?.createdAt ? (ticket.order?.createdAt | date: 'dd MMM yyyy') : '-' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let ticket; columns: displayedColumns"
      class="mass-os-tickets-table__row"
    ></tr>
  </table>

  <div *ngIf="!loading && loaded && !tickets.length" class="mass-os-ticket-expand__empty">
    <ng-container *ngIf="allTicketsHaveOrder; else noPendingTickets">
      Todos los tickets de este servicio ya cuentan con una OS generada
    </ng-container>
    <ng-template #noPendingTickets>Sin tickets para este servicio</ng-template>
  </div>
</div>
